import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../components/ui/table";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function InspectionTypeTable() {
  const token = localStorage.getItem("token");
  const [inspectionTypes, setInspectionTypes] = useState<any[]>([]);
  const navigate = useNavigate();    

  const fetchInspectionTypes = async () => {
    const response = await fetch(`${apiUrl}/inspection_types`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    });

    const result = await response.json();

    if (result.success) {
      setInspectionTypes(result.inspectionTypes);
    } else {
      setInspectionTypes([]);
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }

  useEffect(() => {
    fetchInspectionTypes();
  }, []);

  
  // Map periodtype to readable text
  const getPeriodLabel = (periodtype: number) => {
    switch (periodtype) {
      case 1:
        return "Week";
      case 2:
        return "2 Weeks";
      case 3:
        return "Month";
      case 4:
        return "3 Months";
      case 5:
        return "6 Months";
      case 6:
        return "Year";
      default:
        return "N/A";
    }
  };

  const handleRowClick = (inspectionType: any) => {
   navigate("/update-inspection-type", { state: { inspectionType } });
  }

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Inspection Type Name
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Auto Renew
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Renew Period
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {inspectionTypes.map((inspectionType) => (
            <TableRow className="cursor-pointer hover:bg-[#ffffa3]"  onClick={() => handleRowClick(inspectionType)} key={inspectionType.inspectiontype_id}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
              <span>{inspectionType.name}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionType.autorenew === 1 ? "Yes" : "No"}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{getPeriodLabel(inspectionType.periodtype)}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    
    </>
  )
}